import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const MyCarMainNone = () => {

	const App = useApp()
	const [carData, setCarData] = useState()

	const dataOpen = () => {
		setCarData(!carData)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className="flex-justify_between align_center">
					<h3>내 차 보기</h3>
					<span className={styles["add-btn"]}>+ 추가</span>
				</div>
				<div className={`${styles["car-detail-box"]} mt_40`}>
					<span>총 시세 금액</span>
					<strong>0원</strong>
				</div>
				<div className="center-cont no-data-box py_40 mt_20">
					<i className="icon icon_no_data" />
					<p className="mt_20">등록한 차량이 없습니다.<br />내 차량을 등록하고 시세를 알아보세요.</p>
				</div>
			</div>
		</div>
	)
}

export default MyCarMainNone